module.exports = __webpack_public_path__ + "static/img/g.40a7df7f.png";